import {_} from 'lodash';
import {IKnockoutComponent, IRule, TCondition} from "../../../index";
import {ObjectTypeId} from "../../../constants";

export namespace nsRuleDerived {
    export const ExactOperators: ReadonlyArray<TCondition> = [
        'Er del av',
        'Er ikke del av',
        'Er ikke lik en av',
        'Er ikke lik',
        'Er lik en av',
        'Er lik',
        'Omfattes av',
        'Omfattes ikke av',
    ] as const

    export const FuzzyOperators: ReadonlyArray<TCondition> = [
        'Inneholder en av',
        'Inneholder',
        'Slutter med en av',
        'Slutter med',
        'Starter med en av',
        'Starter med',
    ] as const

    export const SpecialCaseOperators: ReadonlyArray<TCondition> = [
        'Omfattes av',
        'Omfattes ikke av',
    ] as const

    export function getComponent_department(params: IKnockoutComponent['params'], sourceObjectTypeId: ObjectTypeId): IKnockoutComponent {
        const attribute: IRule['attribute'] = sourceObjectTypeId == ObjectTypeId.User
            ? 'OrgUnitnr'
            : 'DepartmentNumber'

        return {
            name: "component/variable/object-by-any",
            params: _.defaultsDeep(params, {
                attribute: attribute,
                linkable: true,
                objectTypeId: ObjectTypeId.Department,
                syncfieldNames: 'OrgUnitnr',
            }),
        }
    }
}